(() => {
  const root = document.querySelector('[data-registration-router]');
  if (!root || root.dataset.registrationInitialized === 'true') return;
  root.dataset.registrationInitialized = 'true';

  const body = document.body;
  const configElement = root.querySelector('[data-registration-config]');
  let config = { registrationVersion: 'phase-1', internationalEnabled: false, countries: {}, languageForms: {} };
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('Registration configuration could not be read.', error);
  }

  const shell = root.dataset.shell || 'international';
  const shopifyMarket = root.dataset.shopifyMarket || '';
  const marketPurchaseCountry = root.dataset.marketPurchaseCountry || '';
  const internationalSwitchCountry = (root.dataset.internationalSwitchCountry || '').toUpperCase();
  const previewCountry = (root.dataset.previewCountry || '').toUpperCase();
  const browsingCountry = (root.dataset.browsingCountry || '').toUpperCase();
  const registrationUrl = new URL(window.location.href);
  const routedCountry = (registrationUrl.searchParams.get('registration_country') || '').toUpperCase();
  const previewThemeRole = String(window.Shopify?.theme?.role || '').toLowerCase();
  const isUnpublishedPreview = previewThemeRole !== '' && previewThemeRole !== 'main';
  const previewDetectionCountryParam = (registrationUrl.searchParams.get('registration_preview_country') || '').toUpperCase();
  const previewReset = isUnpublishedPreview && registrationUrl.searchParams.get('registration_preview_reset') === '1';
  const storageKey = 'soocas.registration.phase1.purchaseCountry';
  const languageStorageKey = 'soocas.registration.phase1.selectedLanguage';
  const countryDialog = root.querySelector('[data-registration-country-dialog]');
  const policyDialog = root.querySelector('[data-registration-policy-dialog]');
  const privacyDialog = root.querySelector('[data-registration-privacy-dialog]');
  const countrySelect = root.querySelector('[data-registration-country-select]');
  const countryDialogClose = root.querySelector('[data-registration-close-dialog]');
  const languageSwitcher = root.querySelector('[data-registration-language-switcher]');
  const localLanguageButton = root.querySelector('[data-registration-language-local]');
  const englishLanguageButton = root.querySelector('[data-registration-language-en]');
  const suggestionElement = root.querySelector('[data-registration-suggestion]');
  const statusElement = root.querySelector('[data-registration-status]');
  const safeContent = root.querySelector('[data-registration-safe-content]');
  const internationalActions = root.querySelector('[data-registration-international-actions]');
  const policyContent = root.querySelector('[data-registration-policy-content]');
  const warrantySummary = root.querySelector('[data-registration-warranty-summary]');
  const warrantyBenefit = root.querySelector('[data-registration-warranty-benefit]');
  const formLoadError = root.querySelector('[data-registration-form-load-error]');
  const formLoadErrorMessage = root.querySelector('[data-registration-form-load-error-message]');
  const formRefreshButton = root.querySelector('[data-registration-form-refresh]');
  const formSupportLink = root.querySelector('[data-registration-form-support]');
  const localizationForm = root.querySelector('#RegistrationMarketSwitchForm');
  const localizationCountryInput = root.querySelector('[data-registration-market-country]');
  const localizationReturnInput = root.querySelector('[data-registration-market-return]');
  const formSectionSelector = "[id$='__17757038274a3009df']";
  const formHostSelector = `${formSectionSelector} .globo-formbuilder`;
  const supportedCountries = ['US', 'GB', 'AU', 'NZ', 'SG', 'MY', 'MX', 'CL', 'KR', 'HK', 'TW', 'ID', 'RU', 'OTHER'];
  const formCountryValues = {
    US: 'United States', GB: 'United Kingdom', AU: 'Australia', NZ: 'New Zealand',
    SG: 'Singapore', MY: 'Malaysia', MX: 'Mexico', CL: 'Chile', KR: 'South Korea',
    HK: 'Hong Kong', TW: 'Taiwan', ID: 'Indonesia', RU: 'Russia', OTHER: 'Other country/region'
  };
  const languages = {
    US: 'en', GB: 'en', AU: 'en', NZ: 'en', SG: 'en', MY: 'ms',
    MX: 'es', CL: 'es', KR: 'ko', HK: 'zh-Hant', TW: 'zh-Hant', ID: 'id', RU: 'ru', OTHER: 'en'
  };
  const dialogLanguages = {
    US: 'en', GB: 'en', AU: 'en', NZ: 'en', SG: 'en', MY: 'ms',
    MX: 'es', CL: 'es', KR: 'ko', HK: 'zh-Hant', TW: 'zh-Hant', ID: 'id', RU: 'ru', OTHER: 'en'
  };
  const languageOptions = {
    US: ['en'], GB: ['en'], AU: ['en'], NZ: ['en'], SG: ['en', 'zh-Hans'], MY: ['ms', 'en'],
    MX: ['es'], CL: ['es'], KR: ['ko'], HK: ['zh-Hant', 'en'], TW: ['zh-Hant'], ID: ['id'], RU: ['ru'], OTHER: ['en']
  };
  const baseFormLanguages = {
    US: 'en', GB: 'en', AU: 'en', NZ: 'en', SG: 'en', MY: 'en',
    MX: 'es', CL: 'es', KR: 'ko', HK: 'zh-Hant', TW: 'zh-Hant', ID: 'id', RU: 'ru'
  };
  const languageNames = { en: 'English', ms: 'Bahasa Melayu', es: 'Español', ko: '한국어', 'zh-Hans': '简体中文', 'zh-Hant': '繁體中文', id: 'Bahasa Indonesia', ru: 'Русский' };
  const countryLabels = {
    en: {
      US: 'United States', GB: 'United Kingdom', AU: 'Australia', NZ: 'New Zealand', SG: 'Singapore', MY: 'Malaysia', MX: 'Mexico', CL: 'Chile',
      KR: 'South Korea', HK: 'Hong Kong (China)', TW: 'Taiwan (China)', ID: 'Indonesia', RU: 'Russia', OTHER: 'Other country/region'
    },
    es: {
      US: 'Estados Unidos', GB: 'Reino Unido', AU: 'Australia', NZ: 'Nueva Zelanda', SG: 'Singapur', MY: 'Malasia', MX: 'México', CL: 'Chile',
      KR: 'Corea del Sur', HK: 'Hong Kong (China)', TW: 'Taiwán (China)', ID: 'Indonesia', RU: 'Rusia', OTHER: 'Otro país o región'
    },
    ko: {
      US: '미국', GB: '영국', AU: '호주', NZ: '뉴질랜드', SG: '싱가포르', MY: '말레이시아', MX: '멕시코', CL: '칠레',
      KR: '대한민국', HK: '홍콩(중국)', TW: '대만(중국)', ID: '인도네시아', RU: '러시아', OTHER: '기타 국가/지역'
    },
    'zh-Hans': {
      US: '美国', GB: '英国', AU: '澳大利亚', NZ: '新西兰', SG: '新加坡', MY: '马来西亚', MX: '墨西哥', CL: '智利',
      KR: '韩国', HK: '香港（中国）', TW: '台湾（中国）', ID: '印度尼西亚', RU: '俄罗斯', OTHER: '其他国家/地区'
    },
    'zh-Hant': {
      US: '美國', GB: '英國', AU: '澳洲', NZ: '紐西蘭', SG: '新加坡', MY: '馬來西亞', MX: '墨西哥', CL: '智利',
      KR: '韓國', HK: '香港（中國）', TW: '台灣（中國）', ID: '印度尼西亞', RU: '俄羅斯', OTHER: '其他國家/地區'
    },
    ms: {
      US: 'Amerika Syarikat', GB: 'United Kingdom', AU: 'Australia', NZ: 'New Zealand', SG: 'Singapura', MY: 'Malaysia', MX: 'Mexico', CL: 'Chile',
      KR: 'Korea Selatan', HK: 'Hong Kong (China)', TW: 'Taiwan (China)', ID: 'Indonesia', RU: 'Rusia', OTHER: 'Negara/wilayah lain'
    },
    id: {
      US: 'Amerika Serikat', GB: 'Britania Raya', AU: 'Australia', NZ: 'Selandia Baru', SG: 'Singapura', MY: 'Malaysia', MX: 'Meksiko', CL: 'Cile',
      KR: 'Korea Selatan', HK: 'Hong Kong (Tiongkok)', TW: 'Taiwan (Tiongkok)', ID: 'Indonesia', RU: 'Rusia', OTHER: 'Negara/wilayah lain'
    },
    ru: {
      US: 'США', GB: 'Великобритания', AU: 'Австралия', NZ: 'Новая Зеландия', SG: 'Сингапур', MY: 'Малайзия', MX: 'Мексика', CL: 'Чили',
      KR: 'Южная Корея', HK: 'Гонконг (Китай)', TW: 'Тайвань (Китай)', ID: 'Индонезия', RU: 'Россия', OTHER: 'Другая страна/регион'
    }
  };
  const translations = {
    en: {
      purchaseLabel: 'Original purchase country/region', warrantyForPurchasesIn: 'Warranty for purchases in', changeCountry: 'Change country/region', eyebrow: 'Warranty registration', title: 'Register your Soocas product',
      safeBody: 'Warranty terms and registration availability depend on the original country or region of purchase.',
      confirmTitle: 'Confirm the original purchase country/region', confirmBody: 'Select where the product was originally purchased. This controls the registration form and warranty information only.',
      countryField: 'Country/region of purchase', confirm: 'Confirm and continue', marketNote: 'The page will reload so its navigation matches the selected purchase country/region.',
      support: 'Contact Customer Support', policy: 'View warranty policy', pending: 'Registration for this purchase country/region is not configured yet. Please contact Customer Support.',
      internationalOff: 'International form submission is unavailable during phase-one setup. Country selection and policy routing remain available for review.',
      other: 'If you cannot find the country or region where you purchased your Soocas product among the available options, please contact our customer support team for assistance.',
      policyPending: 'Country-specific warranty policy content is not configured yet. Please contact Customer Support for the applicable terms.',
      suggested: 'We detected {country} as a suggestion. Confirm it or choose the original purchase country/region.',
      formLoadError: 'The registration form is taking longer than expected to load. Please refresh the page and try again. If the issue continues, contact Customer Support.',
      refreshPage: 'Refresh page'
    },
    'zh-Hans': {
      purchaseLabel: '原始购买国家/地区', warrantyForPurchasesIn: '质保适用于购买地', changeCountry: '更改国家/地区', eyebrow: '质保登记', title: '登记您的 Soocas 产品',
      safeBody: '质保条款和登记资格取决于产品的原始购买国家或地区。',
      confirmTitle: '确认原始购买国家/地区', confirmBody: '请选择产品的原始购买地。此选择仅用于登记表单和质保信息。',
      countryField: '购买国家/地区', confirm: '确认并继续', marketNote: '页面将重新加载，以显示与所选购买国家/地区一致的导航。',
      support: '联系客户支持', policy: '质保政策', pending: '该购买国家/地区的登记表单尚未配置。请联系客户支持。',
      internationalOff: '国际版表单在第一阶段设置期间暂不可提交。国家选择和政策路由仍可用于审核。',
      other: '该国家/地区暂不支持在线登记。请联系客户支持。',
      policyPending: '该国家/地区的质保政策尚未配置。请联系客户支持了解适用条款。',
      suggested: '我们建议选择 {country}。请确认，或选择产品的原始购买国家/地区。',
      formLoadError: '表单加载时间超过预期。请刷新页面后重试；如果问题仍然存在，请联系客户支持。',
      refreshPage: '刷新页面'
    },
    ms: {
      purchaseLabel: 'Negara/wilayah pembelian asal', warrantyForPurchasesIn: 'Waranti untuk pembelian di', changeCountry: 'Tukar negara/wilayah', eyebrow: 'Pendaftaran waranti', title: 'Daftarkan produk Soocas anda',
      safeBody: 'Terma waranti dan ketersediaan pendaftaran bergantung pada negara atau wilayah pembelian asal.',
      confirmTitle: 'Sahkan negara/wilayah pembelian asal', confirmBody: 'Pilih tempat produk dibeli pada asalnya. Pilihan ini hanya mengawal borang pendaftaran dan maklumat waranti.',
      countryField: 'Negara/wilayah pembelian', confirm: 'Sahkan dan teruskan', marketNote: 'Halaman akan dimuat semula supaya navigasi sepadan dengan negara/wilayah pembelian yang dipilih.',
      support: 'Hubungi Sokongan Pelanggan', policy: 'Polisi Waranti', pending: 'Borang pendaftaran untuk negara/wilayah pembelian ini belum dikonfigurasi. Sila hubungi Sokongan Pelanggan.',
      internationalOff: 'Penghantaran borang antarabangsa tidak tersedia semasa persediaan fasa pertama. Pemilihan negara dan laluan polisi masih tersedia untuk semakan.',
      other: 'Pendaftaran dalam talian tidak tersedia untuk negara/wilayah ini. Sila hubungi Sokongan Pelanggan.',
      policyPending: 'Polisi waranti khusus negara/wilayah ini belum dikonfigurasi. Sila hubungi Sokongan Pelanggan untuk terma yang berkenaan.',
      suggested: 'Kami mencadangkan {country}. Sila sahkan atau pilih negara/wilayah pembelian asal.',
      formLoadError: 'Borang mengambil masa lebih lama daripada jangkaan untuk dimuatkan. Sila muat semula halaman dan cuba lagi. Jika masalah berterusan, hubungi Sokongan Pelanggan.',
      refreshPage: 'Muat semula halaman'
    },
    es: {
      purchaseLabel: 'País o región de compra original', warrantyForPurchasesIn: 'Garantía para compras en', changeCountry: 'Cambiar país o región', eyebrow: 'Registro de garantía', title: 'Registra tu producto Soocas',
      safeBody: 'Las condiciones de garantía y la disponibilidad del registro dependen del país o región de compra original.',
      confirmTitle: 'Confirma el país o región de compra original', confirmBody: 'Selecciona dónde se compró originalmente el producto. Esto solo controla el formulario y la información de garantía.',
      countryField: 'País o región de compra', confirm: 'Confirmar y continuar', marketNote: 'La página se volverá a cargar para que la navegación coincida con el país o región de compra seleccionado.',
      support: 'Contactar con Atención al Cliente', policy: 'Política de garantía', pending: 'El registro para este país o región aún no está configurado. Contacta con Atención al Cliente.',
      internationalOff: 'El envío del formulario internacional no está disponible durante la primera fase. La selección de país y la ruta de la política están disponibles para revisión.',
      other: 'El registro en línea no está disponible para este país o región. Contacta con Atención al Cliente.',
      policyPending: 'La política de garantía específica de este país aún no está configurada. Contacta con Atención al Cliente.',
      suggested: 'Detectamos {country} como sugerencia. Confírmalo o elige el país o región de compra original.',
      formLoadError: 'El formulario está tardando más de lo esperado en cargarse. Actualiza la página e inténtalo de nuevo. Si el problema continúa, contacta con Atención al Cliente.',
      refreshPage: 'Actualizar página'
    },
    ko: {
      purchaseLabel: '최초 구매 국가/지역', warrantyForPurchasesIn: '구매 국가/지역별 보증', changeCountry: '국가/지역 변경', eyebrow: '보증 등록', title: 'Soocas 제품 등록',
      safeBody: '보증 조건과 등록 가능 여부는 최초 구매 국가 또는 지역에 따라 달라집니다.',
      confirmTitle: '최초 구매 국가/지역 확인', confirmBody: '제품을 처음 구매한 곳을 선택하세요. 등록 양식과 보증 정보에만 적용됩니다.',
      countryField: '구매 국가/지역', confirm: '확인 후 계속', marketNote: '선택한 구매 국가/지역에 맞는 탐색 메뉴를 표시하기 위해 페이지가 새로고침됩니다.',
      support: '고객 지원 문의', policy: '보증 정책', pending: '이 구매 국가/지역의 등록은 아직 설정되지 않았습니다. 고객 지원에 문의하세요.',
      internationalOff: '1단계 설정 중에는 국제 양식 제출을 이용할 수 없습니다. 국가 선택과 정책 경로는 검토할 수 있습니다.',
      other: '이 국가/지역에서는 온라인 등록을 이용할 수 없습니다. 고객 지원에 문의하세요.',
      policyPending: '국가별 보증 정책이 아직 설정되지 않았습니다. 적용 조건은 고객 지원에 문의하세요.',
      suggested: '{country}이(가) 제안되었습니다. 확인하거나 최초 구매 국가/지역을 선택하세요.',
      formLoadError: '양식을 불러오는 데 예상보다 오래 걸리고 있습니다. 페이지를 새로고침한 후 다시 시도해 주세요. 문제가 계속되면 고객 지원팀에 문의해 주세요.',
      refreshPage: '페이지 새로고침'
    },
    'zh-Hant': {
      purchaseLabel: '原始購買國家/地區', warrantyForPurchasesIn: '保固適用於購買地', changeCountry: '更改國家/地區', eyebrow: '保固登記', title: '登記您的 Soocas 產品',
      safeBody: '保固條款與登記可用性取決於原始購買國家或地區。', confirmTitle: '確認原始購買國家/地區',
      confirmBody: '請選擇產品原始購買地。這只會控制登記表單與保固資訊。', countryField: '購買國家/地區', confirm: '確認並繼續',
      marketNote: '頁面將重新載入，以顯示符合所選購買國家/地區的導覽。', support: '聯絡客戶支援', policy: '保固政策',
      pending: '此購買國家/地區的登記尚未設定。請聯絡客戶支援。', internationalOff: '國際版表單在第一階段設定期間暫不開放送出。國家選擇與政策路由可供檢視。',
      other: '此國家/地區不提供線上登記。請聯絡客戶支援。', policyPending: '此國家/地區的保固政策尚未設定。請聯絡客戶支援取得適用條款。',
      suggested: '偵測到 {country} 作為建議。請確認，或選擇原始購買國家/地區。',
      formLoadError: '表單載入時間超出預期。請重新整理頁面後再試；如果問題仍然存在，請聯絡客戶支援。',
      refreshPage: '重新整理頁面'
    },
    id: {
      purchaseLabel: 'Negara/wilayah pembelian awal', warrantyForPurchasesIn: 'Garansi untuk pembelian di', changeCountry: 'Ubah negara/wilayah', eyebrow: 'Pendaftaran garansi', title: 'Daftarkan produk Soocas Anda',
      safeBody: 'Ketentuan garansi dan ketersediaan pendaftaran bergantung pada negara atau wilayah pembelian awal.', confirmTitle: 'Konfirmasi negara/wilayah pembelian awal',
      confirmBody: 'Pilih tempat produk pertama kali dibeli. Pilihan ini hanya mengatur formulir pendaftaran dan informasi garansi.', countryField: 'Negara/wilayah pembelian', confirm: 'Konfirmasi dan lanjutkan',
      marketNote: 'Halaman akan dimuat ulang agar navigasi sesuai dengan negara/wilayah pembelian yang dipilih.', support: 'Hubungi Dukungan Pelanggan', policy: 'Kebijakan Garansi',
      pending: 'Pendaftaran untuk negara/wilayah ini belum dikonfigurasi. Hubungi Dukungan Pelanggan.', internationalOff: 'Pengiriman formulir internasional belum tersedia selama pengaturan tahap pertama. Pemilihan negara dan rute kebijakan tetap tersedia untuk ditinjau.',
      other: 'Pendaftaran online tidak tersedia untuk negara/wilayah ini. Hubungi Dukungan Pelanggan.', policyPending: 'Kebijakan garansi khusus negara ini belum dikonfigurasi. Hubungi Dukungan Pelanggan untuk ketentuan yang berlaku.',
      suggested: 'Kami mendeteksi {country} sebagai saran. Konfirmasikan atau pilih negara/wilayah pembelian awal.',
      formLoadError: 'Formulir memerlukan waktu lebih lama dari yang diperkirakan untuk dimuat. Silakan muat ulang halaman dan coba lagi. Jika masalah berlanjut, hubungi Dukungan Pelanggan.',
      refreshPage: 'Muat ulang halaman'
    },
    ru: {
      purchaseLabel: 'Страна/регион первоначальной покупки', warrantyForPurchasesIn: 'Гарантия для страны/региона покупки', changeCountry: 'Изменить страну/регион', eyebrow: 'Регистрация гарантии', title: 'Зарегистрируйте продукт Soocas',
      safeBody: 'Условия гарантии и доступность регистрации зависят от страны или региона первоначальной покупки.', confirmTitle: 'Подтвердите страну/регион первоначальной покупки',
      confirmBody: 'Выберите, где продукт был первоначально куплен. Это влияет только на форму и информацию о гарантии.', countryField: 'Страна/регион покупки', confirm: 'Подтвердить и продолжить',
      marketNote: 'Страница перезагрузится, чтобы навигация соответствовала выбранной стране/региону покупки.', support: 'Связаться с поддержкой', policy: 'Гарантийная политика',
      pending: 'Регистрация для этой страны/региона еще не настроена. Обратитесь в поддержку.', internationalOff: 'Отправка международной формы недоступна на первом этапе. Выбор страны и маршрут политики доступны для проверки.',
      other: 'Онлайн-регистрация недоступна для этой страны/региона. Обратитесь в поддержку.', policyPending: 'Гарантийная политика для этой страны еще не настроена. Обратитесь в поддержку.',
      suggested: 'Предложено: {country}. Подтвердите или выберите страну/регион первоначальной покупки.',
      formLoadError: 'Загрузка формы занимает больше времени, чем ожидалось. Обновите страницу и повторите попытку. Если проблема сохраняется, обратитесь в службу поддержки.',
      refreshPage: 'Обновить страницу'
    }
  };
  const countryDialogTranslations = {
    US: {
      eyebrow: 'Warranty Registration',
      title: 'Confirm the Country/Region of Purchase',
      message: 'Based on your region, we suggest {country}. Please confirm or choose another purchase country/region.',
      selectorLabel: 'Country/Region of Purchase',
      cta: 'Confirm and Continue',
      disclaimer: 'Please select the country/region where the product was actually purchased, not your current location. An incorrect selection may affect warranty registration, eligibility for an extended warranty, and subsequent after-sales support.'
    },
    GB: {
      eyebrow: 'Warranty Registration',
      title: 'Confirm the Country/Region of Purchase',
      message: 'Based on your region, we suggest {country}. Please confirm or choose another purchase country/region.',
      selectorLabel: 'Country/Region of Purchase',
      cta: 'Confirm and Continue',
      disclaimer: 'Please select the country/region where the product was actually purchased, not your current location. An incorrect selection may affect warranty registration, eligibility for an extended warranty, and subsequent after-sales support.'
    },
    AU: {
      eyebrow: 'Warranty Registration',
      title: 'Confirm the Country/Region of Purchase',
      message: 'Based on your region, we suggest {country}. Please confirm or choose another purchase country/region.',
      selectorLabel: 'Country/Region of Purchase',
      cta: 'Confirm and Continue',
      disclaimer: 'Please select the country/region where the product was actually purchased, not your current location. An incorrect selection may affect warranty registration, eligibility for an extended warranty, and subsequent after-sales support.'
    },
    NZ: {
      eyebrow: 'Warranty Registration',
      title: 'Confirm the Country/Region of Purchase',
      message: 'Based on your region, we suggest {country}. Please confirm or choose another purchase country/region.',
      selectorLabel: 'Country/Region of Purchase',
      cta: 'Confirm and Continue',
      disclaimer: 'Please select the country/region where the product was actually purchased, not your current location. An incorrect selection may affect warranty registration, eligibility for an extended warranty, and subsequent after-sales support.'
    },
    SG: {
      eyebrow: 'Warranty Registration',
      title: 'Confirm the Country/Region of Purchase',
      message: 'Based on your region, we suggest {country}. Please confirm or choose another purchase country/region.',
      selectorLabel: 'Country/Region of Purchase',
      cta: 'Confirm and Continue',
      disclaimer: 'Please select the country/region where the product was actually purchased, not your current location. An incorrect selection may affect warranty registration, eligibility for an extended warranty, and subsequent after-sales support.'
    },
    MY: {
      eyebrow: 'Pendaftaran Waranti',
      title: 'Sahkan Negara/Wilayah Pembelian Produk',
      message: 'Berdasarkan rantau anda, kami mengesyorkan {country}. Sila sahkan atau pilih negara/wilayah pembelian yang lain.',
      selectorLabel: 'Negara/Wilayah Pembelian Produk',
      cta: 'Sahkan dan Teruskan',
      disclaimer: 'Sila pilih negara/wilayah tempat produk sebenarnya dibeli, bukan negara/wilayah tempat anda berada sekarang. Pilihan yang salah boleh menjejaskan pendaftaran waranti, kelayakan waranti lanjutan dan sokongan selepas jualan seterusnya.'
    },
    MX: {
      eyebrow: 'Registro de garantía',
      title: 'Confirma el país o región de compra del producto',
      message: 'Según su región, sugerimos {country}. Confirme o seleccione otro país o región de compra.',
      selectorLabel: 'País/región de compra del producto',
      cta: 'Confirmar y continuar',
      disclaimer: 'Seleccione el país o región donde se compró realmente el producto, no el país o región donde se encuentra actualmente. Una selección incorrecta puede afectar el registro de la garantía, la elegibilidad para una garantía extendida y la atención posventa posterior.'
    },
    CL: {
      eyebrow: 'Registro de garantía',
      title: 'Confirma el país o región de compra del producto',
      message: 'Según su región, sugerimos {country}. Confirme o seleccione otro país o región de compra.',
      selectorLabel: 'País/región de compra del producto',
      cta: 'Confirmar y continuar',
      disclaimer: 'Seleccione el país o región donde se compró realmente el producto, no el país o región donde se encuentra actualmente. Una selección incorrecta puede afectar el registro de la garantía, la elegibilidad para una garantía extendida y la atención posventa posterior.'
    },
    KR: {
      eyebrow: '보증 등록',
      title: '제품 구매 국가/지역을 확인해 주세요',
      message: '접속 지역을 기준으로 권장되는 국가/지역은 {country}입니다. 확인하거나 다른 구매 국가/지역을 선택해 주세요.',
      selectorLabel: '제품 구매 국가/지역',
      cta: '확인 후 계속',
      disclaimer: '현재 계신 국가/지역이 아니라 제품을 실제로 구매한 국가/지역을 선택해 주세요. 잘못 선택하면 보증 등록, 연장 보증 대상 여부 및 이후 고객 지원에 영향을 줄 수 있습니다.'
    },
    HK: {
      eyebrow: '保養登記',
      title: '請確認產品購買國家/地區',
      message: '根據您的瀏覽地區，我們建議選擇 {country}。請確認或選擇其他產品購買國家/地區。',
      selectorLabel: '產品購買國家/地區',
      cta: '確認並繼續',
      disclaimer: '請選擇產品實際購買的國家/地區，而非您目前所在的國家/地區。選擇錯誤可能影響保養登記、延長保養資格及後續售後處理。'
    },
    TW: {
      eyebrow: '保固登記',
      title: '請確認產品購買國家/地區',
      message: '根據您的連線地區，我們建議選擇 {country}。請確認或選擇其他產品購買國家/地區。',
      selectorLabel: '產品購買國家/地區',
      cta: '確認並繼續',
      disclaimer: '請選擇產品實際購買的國家/地區，而非您目前所在的國家/地區。選擇錯誤可能影響保固登記、延長保固資格及後續售後處理。'
    },
    ID: {
      eyebrow: 'Pendaftaran Garansi',
      title: 'Konfirmasi Negara/Wilayah Pembelian Produk',
      message: 'Berdasarkan wilayah Anda, kami menyarankan {country}. Silakan konfirmasi atau pilih negara/wilayah pembelian lainnya.',
      selectorLabel: 'Negara/Wilayah Pembelian Produk',
      cta: 'Konfirmasi dan Lanjutkan',
      disclaimer: 'Pilih negara/wilayah tempat produk benar-benar dibeli, bukan negara/wilayah tempat Anda berada saat ini. Pilihan yang salah dapat memengaruhi pendaftaran garansi, kelayakan perpanjangan garansi, dan layanan purnajual selanjutnya.'
    },
    RU: {
      eyebrow: 'Регистрация гарантии',
      title: 'Подтвердите страну/регион покупки товара',
      message: 'С учетом вашего региона рекомендуемая страна/регион — {country}. Подтвердите выбор или укажите другую страну/регион покупки.',
      selectorLabel: 'Страна/регион покупки товара',
      cta: 'Подтвердить и продолжить',
      disclaimer: 'Выберите страну/регион, где товар был фактически приобретен, а не страну/регион вашего текущего местонахождения. Неверный выбор может повлиять на регистрацию гарантии, право на расширенную гарантию и дальнейшее послепродажное обслуживание.'
    }
  };
  const countryDialogAlternativeTranslations = {
    SG: {
      'zh-Hans': {
        eyebrow: '质保登记',
        title: '请确认产品购买国家/地区',
        message: '根据您的访问地区，我们建议选择 {country}。请确认，或选择其他产品购买国家/地区。',
        selectorLabel: '产品购买国家/地区',
        cta: '确认并继续',
        disclaimer: '请选择产品实际购买的国家/地区，而非您当前所在的国家/地区。选择错误可能影响质保登记、延长质保资格及后续售后处理。'
      }
    },
    HK: {
      en: {
        eyebrow: 'Warranty Registration',
        title: 'Confirm the Country/Region of Purchase',
        message: 'Based on your region, we suggest {country}. Please confirm or select another country/region of purchase.',
        selectorLabel: 'Country/Region of Purchase',
        cta: 'Confirm and Continue',
        disclaimer: 'Please select the country/region where the product was actually purchased, not your current location. An incorrect selection may affect warranty registration, eligibility for an extended warranty, and subsequent after-sales support.'
      }
    }
  };
  const countryDialogFallbackMessage = 'To ensure accurate warranty registration and after-sales support, please select the correct country/region where the product was purchased.';
  const introTranslations = {
    en: { heading: 'Register for an Extra Year of Warranty', body: 'Complete the form below to activate one additional year of warranty coverage.', cardLabel: "WHAT'S INCLUDED", benefits: ['1 Extra Year of Coverage — Complimentary', 'Replacement for covered defects', 'Priority customer support.', 'No deductibles, no return shipping fees.'], footnote: 'Warranty terms vary by region and are based on the original country of purchase.' },
    es: { heading: 'Registra tu producto para obtener un año adicional de garantía', body: 'Completa el formulario para activar un año adicional de cobertura.', cardLabel: 'QUÉ INCLUYE', benefits: ['Un año adicional de cobertura — Sin costo', 'Reemplazo por defectos cubiertos', 'Atención al cliente prioritaria.', 'Sin deducibles ni gastos de envío por devolución.'], footnote: 'Las condiciones de garantía varían según la región y se basan en el país de compra original.' },
    ko: { heading: '1년 추가 보증을 등록하세요', body: '아래 양식을 작성하면 보증 기간 1년이 추가됩니다.', cardLabel: '포함 혜택', benefits: ['보증 기간 1년 추가 — 무료', '보증 대상 결함 제품 교체', '우선 고객 지원', '공제액 및 반품 배송비 없음'], footnote: '보증 조건은 지역과 최초 구매 국가에 따라 달라집니다.' },
    'zh-Hans': { heading: '登记即可延长一年质保', body: '填写下方表单即可激活额外一年的质保。', cardLabel: '包含权益', benefits: ['额外一年质保 — 免费', '更换符合条件的缺陷产品', '优先客户支持', '无免赔额，无退货运费'], footnote: '质保条款因地区而异，并以产品原始购买国家/地区为准。' },
    'zh-Hant': { heading: '登記即可延長一年保固', body: '填寫下方表單即可啟用額外一年的保固。', cardLabel: '包含權益', benefits: ['額外一年保固 — 免費', '更換符合條件的瑕疵產品', '優先客戶支援', '無自付額，無退貨運費'], footnote: '保固條款因地區而異，並以產品原始購買國家/地區為準。' },
    ms: { heading: 'Daftarkan untuk tambahan satu tahun waranti', body: 'Lengkapkan borang di bawah untuk mengaktifkan tambahan satu tahun perlindungan waranti.', cardLabel: 'APA YANG DISERTAKAN', benefits: ['Tambahan satu tahun perlindungan — Percuma', 'Penggantian untuk kecacatan yang dilindungi', 'Sokongan pelanggan keutamaan', 'Tiada bayaran lebihan atau penghantaran pemulangan'], footnote: 'Terma waranti berbeza mengikut rantau dan berdasarkan negara pembelian asal.' },
    id: { heading: 'Daftarkan untuk tambahan satu tahun garansi', body: 'Lengkapi formulir di bawah untuk mengaktifkan tambahan satu tahun perlindungan garansi.', cardLabel: 'YANG TERMASUK', benefits: ['Tambahan satu tahun perlindungan — Gratis', 'Penggantian untuk cacat yang tercakup', 'Dukungan pelanggan prioritas', 'Tanpa biaya pengurangan atau pengiriman retur'], footnote: 'Ketentuan garansi berbeda menurut wilayah dan berdasarkan negara pembelian awal.' },
    ru: { heading: 'Зарегистрируйте продукт и получите дополнительный год гарантии', body: 'Заполните форму ниже, чтобы активировать дополнительный год гарантийного покрытия.', cardLabel: 'ЧТО ВКЛЮЧЕНО', benefits: ['Дополнительный год покрытия — бесплатно', 'Замена при покрываемых дефектах', 'Приоритетная поддержка клиентов', 'Без франшизы и платы за обратную доставку'], footnote: 'Условия гарантии зависят от региона и страны первоначальной покупки.' }
  };

  let purchaseCountry = '';
  let detectedCountry = '';
  let uiLanguage = 'en';
  let selectedLanguage = 'en';
  let activeLanguage = 'en';
  let dialogLanguageCountry = '';
  let countryConfirmationRequired = false;
  let languageUserSelected = false;
  let countrySelectionTouched = false;
  let activeFormId = '';
  let lastFocusedElement = null;
  let formRequestId = 0;
  let formConfigurationInFlight = false;

  const currentCopy = () => translations[uiLanguage] || translations.en;
  const localizedCountryName = (country, language = uiLanguage) => (countryLabels[language] || countryLabels.en)[country] || countryLabels.en[country] || country;
  const countryConfig = (country) => config.countries[country] || null;
  const validCountry = (country) => supportedCountries.includes((country || '').toUpperCase());
  const normalizeCountry = (country) => validCountry(country) ? country.toUpperCase() : 'OTHER';
  const defaultLanguageForCountry = (country) => languages[normalizeCountry(country)] || 'en';
  const localeForCountry = (country, language) => {
    const normalizedCountry = normalizeCountry(country);
    const localeMap = {
      en: {
        US: 'en-US', GB: 'en-GB', AU: 'en-AU', NZ: 'en-NZ', SG: 'en-SG',
        MY: 'en-MY', HK: 'en-HK', TW: 'en-TW', ID: 'en-ID', RU: 'en-RU'
      },
      es: { MX: 'es-MX', CL: 'es-CL' },
      ko: { KR: 'ko-KR' },
      'zh-Hans': { SG: 'zh-CN' },
      'zh-Hant': { HK: 'zh-HK', TW: 'zh-TW' },
      ms: { MY: 'ms-MY' },
      id: { ID: 'id-ID' },
      ru: { RU: 'ru-RU' }
    };
    return localeMap[language]?.[normalizedCountry] || localeMap[language]?.US || language || 'en';
  };

  const readFormValue = (form, fieldName) => {
    if (!form) return '';
    const checkedField = form.querySelector(`input[name="${fieldName}"]:checked`);
    if (checkedField) return String(checkedField.value || '').trim();
    const field = form.querySelector(`[name="${fieldName}"]`);
    return String(field?.value || '').trim();
  };

  const parseCalendarDate = (value) => {
    const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
    return { year, month, day };
  };

  const warrantyCoverageFor = (purchaseDate, warrantyYears, locale) => {
    const parsedDate = parseCalendarDate(purchaseDate);
    const years = Number(warrantyYears);
    if (!parsedDate || !Number.isFinite(years) || years < 1) return { iso: '', display: '' };
    const targetYear = parsedDate.year + years;
    const lastDayOfTargetMonth = new Date(Date.UTC(targetYear, parsedDate.month, 0)).getUTCDate();
    const targetDay = Math.min(parsedDate.day, lastDayOfTargetMonth);
    const date = new Date(Date.UTC(targetYear, parsedDate.month - 1, targetDay));
    const iso = `${targetYear}-${String(parsedDate.month).padStart(2, '0')}-${String(targetDay).padStart(2, '0')}`;
    let display = iso;
    try {
      display = new Intl.DateTimeFormat(locale, {
        year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'
      }).format(date);
    } catch (error) {}
    return { iso, display };
  };


  // Sync the warranty end date to each active PFB form's native Hidden Field.
  // The country, language and form ID come from Warranty Market Router.
  // Forms without a configured "Warranty End Date" field remain unchanged.
  const bindWarrantyEndDate = (form, formId) => {
    if (!form || !purchaseCountry || purchaseCountry === 'OTHER') return;

    // Never update an inactive country or language form.
    const isCurrentForm = () =>
      String(formId) === String(activeFormId) &&
      String(formId) === String(formIdFor(purchaseCountry, selectedLanguage));

    if (!isCurrentForm()) return;

    const getConfiguredYears = () => {
      const value = countryConfig(purchaseCountry)?.warrantyYears;
      if (value === undefined || value === null || value === '') return null;
      const years = Number(value);
      return Number.isInteger(years) && years > 0 ? years : null;
    };

    // Do not silently default an unconfigured country to 2 or 3 years.
    if (getConfiguredYears() === null) return;

    const dateInput = form.querySelector('[name="datetime-2"]');
    if (!dateInput) return;

    // Identify the PFB-native hidden field by its configured label, not ID.
    // Future forms may use hidden-2, hidden-3, etc.
    const getHiddenInput = () => {
      const controls = form.querySelectorAll(
        '.globo-form-control[data-element-id][data-type="hidden"]'
      );

      for (const control of controls) {
        const label = control.querySelector('label');
        const fieldLabel = String(
          label?.getAttribute('data-label') ||
          label?.querySelector('.label-content')?.getAttribute('data-label') ||
          label?.textContent ||
          ''
        ).replace(/\s+/g, ' ').trim().toLowerCase();

        if (fieldLabel !== 'warranty end date') continue;

        const input = control.querySelector(
          'input[type="hidden"][data-type="fixed"]'
        );
        if (
          input &&
          /^hidden-\d+$/.test(input.name) &&
          input.name === control.getAttribute('data-element-id')
        ) return input;
      }

      return null;
    };

    // The native PFB field is optional until this country form is configured.
    if (!getHiddenInput()) return;


    const sync = () => {
      if (!isCurrentForm()) return;

      const hidden = getHiddenInput();
      if (!hidden) return;

      const years = getConfiguredYears();

      const coverage = years === null
        ? { iso: '' }
        : warrantyCoverageFor(
            readFormValue(form, 'datetime-2'),
            years,
            localeForCountry(purchaseCountry, selectedLanguage)
          );

      const nextValue = coverage.iso || '';

      // Synchronize PFB's internal fixedValue.
      // PFB uses this value when processing native Hidden Fields.
      const runtimeElements =
        window.Globo?.FormBuilder?.forms?.[String(formId)]?.elements;

      const runtimeField = collectFormElements(runtimeElements)
        .find((element) =>
          String(element?.id || '') === hidden.name &&
          element?.type === 'hidden' &&
          element?.dataType === 'fixed'
        );

      if (
        runtimeField &&
        runtimeField.fixedValue !== nextValue
      ) {
        runtimeField.fixedValue = nextValue;
      }

      // Keep the DOM field synchronized as well.
      if (hidden.value !== nextValue) {
        hidden.value = nextValue;

        hidden.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        hidden.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    };


    // Sync when the purchase date changes (including Flatpickr selections).
    if (dateInput.dataset.soocasWarrantyDateBound !== 'true') {
      dateInput.addEventListener('input', sync);
      dateInput.addEventListener('change', sync);
      dateInput.dataset.soocasWarrantyDateBound = 'true';
    }

    // Final sync before PFB collects form data; preserve the proven US flow.
    if (form.dataset.soocasWarrantySubmitBound !== 'true') {
      form.addEventListener('submit', sync, true);
      form.addEventListener('click', (event) => {
        if (
          event.target instanceof Element &&
          event.target.closest('button[type="submit"], input[type="submit"]')
        ) sync();
      }, true);
      form.dataset.soocasWarrantySubmitBound = 'true';
    }

    sync();
  };



  const buildRegistrationSuccessDetail = (form) => {
    const selectedConfig = countryConfig(purchaseCountry);
    const warrantyYears = Number(selectedConfig?.warrantyYears || (purchaseCountry === 'US' ? 2 : 3));
    const locale = localeForCountry(purchaseCountry, selectedLanguage);
    const purchaseDate = readFormValue(form, 'datetime-2');
    const coverage = warrantyCoverageFor(purchaseDate, warrantyYears, locale);
    const subscriberValue = ['US', 'GB'].includes(purchaseCountry) ? readFormValue(form, 'radio-1').toLowerCase() : '';
    const subscriberStatus = subscriberValue === 'yes' ? 'yes' : subscriberValue === 'no' ? 'no' : '';
    return {
      ...(window.SoocasRegistrationState || {}),
      purchaseCountry,
      selectedLanguage,
      locale,
      countryDisplayName: localizedCountryName(purchaseCountry, selectedLanguage),
      model: readFormValue(form, 'select-2'),
      purchaseDate,
      warrantyYears,
      coverageThrough: coverage.iso,
      coverageThroughDisplay: coverage.display,
      subscriberStatus
    };
  };
  const supportedLanguagesForCountry = (country) => languageOptions[normalizeCountry(country)] || ['en'];
  const resolveLanguageForCountry = (country, language) => {
    const supported = supportedLanguagesForCountry(country);
    return supported.includes(language) ? language : defaultLanguageForCountry(country);
  };
  const formIdFor = (country, language = selectedLanguage) => {
    const normalizedCountry = normalizeCountry(country);
    const resolvedLanguage = resolveLanguageForCountry(normalizedCountry, language);
    const override = config.languageForms?.[normalizedCountry]?.[resolvedLanguage];
    if (override !== undefined) return String(override || '').trim();
    return baseFormLanguages[normalizedCountry] === resolvedLanguage
      ? String(countryConfig(normalizedCountry)?.formId || '').trim()
      : '';
  };
  const currentCountryDialogCopy = () => {
    const country = normalizeCountry(dialogLanguageCountry || detectedCountry || purchaseCountry || browsingCountry || marketPurchaseCountry || 'OTHER');
    const localLanguage = dialogLanguages[country] || 'en';
    const alternativeCopy = countryDialogAlternativeTranslations[country]?.[uiLanguage];
    if (alternativeCopy) return alternativeCopy;
    if (uiLanguage === 'en' && localLanguage !== 'en') return countryDialogTranslations.US;
    return countryDialogTranslations[country] || countryDialogTranslations.US;
  };
  const previewDetectionCountry = isUnpublishedPreview && validCountry(previewDetectionCountryParam) ? normalizeCountry(previewDetectionCountryParam) : '';
  const expectedShellForCountry = (country) => country === 'US' ? 'us' : country === 'GB' ? 'uk' : country === 'TW' ? 'tw' : 'international';
  const usesFullRegistrationExperience = (country = purchaseCountry) => expectedShellForCountry(country) === shell && ['US', 'GB', 'TW'].includes(country);

  const updateSafeContentVisibility = () => {
    const isOther = purchaseCountry === 'OTHER';
    const isInternational = shell === 'international';
    if (safeContent) safeContent.hidden = !isInternational || !isOther;
    if (internationalActions) internationalActions.hidden = !isInternational || !purchaseCountry || isOther;
  };

  const releasePriorityGate = () => document.documentElement.classList.remove('registration-country-priority');

  const buildReturnTo = (country) => {
    const returnUrl = new URL(window.location.href);
    returnUrl.searchParams.delete('country');
    returnUrl.searchParams.set('registration_country', normalizeCountry(country));
    const previewTheme = window.Shopify?.theme;
    if (previewTheme?.role && previewTheme.role !== 'main' && previewTheme.id) {
      returnUrl.searchParams.set('preview_theme_id', String(previewTheme.id));
    }
    return `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
  };

  const switchStorefrontShell = (country) => {
    if (expectedShellForCountry(country) === shell) return false;
    const routeCountry = country === 'OTHER' ? internationalSwitchCountry : country;
    if (!localizationForm || !localizationCountryInput || !/^[A-Z]{2}$/.test(routeCountry)) return false;
    localizationCountryInput.value = routeCountry;
    if (localizationReturnInput) localizationReturnInput.value = buildReturnTo(country);
    document.documentElement.classList.add('registration-country-priority');
    body.classList.add('registration-dialog-open');
    if (countryDialog) countryDialog.hidden = true;
    requestAnimationFrame(() => localizationForm.submit());
    return true;
  };

  const setDialogState = (dialog, isOpen) => {
    if (!dialog) return;
    if (isOpen) {
      lastFocusedElement = document.activeElement;
      dialog.hidden = false;
      body.classList.add('registration-dialog-open');
      requestAnimationFrame(() => {
        const focusTarget = Array.from(dialog.querySelectorAll('select:not([disabled]), button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'))
          .find((element) => !element.closest('[hidden]'));
        focusTarget?.focus();
      });
    } else {
      dialog.hidden = true;
      if (countryDialog.hidden && policyDialog.hidden && (!privacyDialog || privacyDialog.hidden)) body.classList.remove('registration-dialog-open');
      lastFocusedElement?.focus?.({ preventScroll: true });
    }
  };

  const trapFocus = (event, dialog) => {
    if (event.key !== 'Tab' || dialog.hidden) return;
    const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'))
      .filter((element) => !element.closest('[hidden]'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  const updateCountryLabels = () => {
    if (!countrySelect) return;
    Array.from(countrySelect.options).forEach((option) => {
      option.textContent = localizedCountryName(option.value);
    });
  };

  const updateLanguageSwitcher = () => {
    const country = normalizeCountry(dialogLanguageCountry);
    const [primaryLanguage = 'en', secondaryLanguage = ''] = supportedLanguagesForCountry(country);
    if (languageSwitcher) languageSwitcher.hidden = !secondaryLanguage;
    if (localLanguageButton) {
      localLanguageButton.textContent = languageNames[primaryLanguage] || primaryLanguage;
      localLanguageButton.dataset.language = primaryLanguage;
      localLanguageButton.setAttribute('aria-pressed', String(uiLanguage === primaryLanguage));
    }
    if (englishLanguageButton) {
      englishLanguageButton.textContent = languageNames[secondaryLanguage] || secondaryLanguage;
      englishLanguageButton.dataset.language = secondaryLanguage;
      englishLanguageButton.setAttribute('aria-pressed', String(uiLanguage === secondaryLanguage));
    }
  };

  const updateSuggestion = () => {
    if (!suggestionElement) return;
    const dialogText = currentCountryDialogCopy();
    suggestionElement.textContent = detectedCountry && validCountry(detectedCountry)
      ? dialogText.message.replace('{country}', localizedCountryName(normalizeCountry(detectedCountry)))
      : countryDialogFallbackMessage;
  };

  const applyIntroCopy = () => {
    if (shell === 'us' || shell === 'uk' || shell === 'tw') return;
    const copy = introTranslations[uiLanguage] || introTranslations.en;
    document.querySelectorAll('[data-registration-intro-copy]').forEach((element) => {
      const key = element.dataset.registrationIntroCopy;
      if (key === 'body') element.innerHTML = `<p>${copy.body.replace(/\n/g, '<br>')}</p>`;
      else if (copy[key]) element.textContent = copy[key];
    });
    document.querySelectorAll('[data-registration-intro-benefit]').forEach((element, index) => {
      const textElement = element.querySelector('span:last-child');
      if (textElement && copy.benefits[index]) textElement.textContent = copy.benefits[index];
    });
  };

  const applyCopy = () => {
    const text = currentCopy();
    root.querySelectorAll('[data-copy]').forEach((element) => {
      if (text[element.dataset.copy]) element.textContent = text[element.dataset.copy];
    });
    document.querySelectorAll('[data-registration-context-copy]').forEach((element) => {
      const key = element.dataset.registrationContextCopy;
      if (text[key]) element.textContent = text[key];
    });
    const dialogText = currentCountryDialogCopy();
    countryDialog?.querySelectorAll('[data-registration-dialog-copy]').forEach((element) => {
      const key = element.dataset.registrationDialogCopy;
      if (dialogText[key]) element.textContent = dialogText[key];
    });
    updateCountryLabels();
    updateLanguageSwitcher();
    updateSuggestion();
    applyIntroCopy();
    if (formLoadErrorMessage) formLoadErrorMessage.textContent = text.formLoadError || translations.en.formLoadError;
    if (formRefreshButton) formRefreshButton.textContent = text.refreshPage || translations.en.refreshPage;
    if (formSupportLink) formSupportLink.textContent = text.support || translations.en.support;
    document.documentElement.lang = uiLanguage;
  };

  const setUiLanguage = (language, userSelected = false) => {
    const supportsLanguage = Boolean(translations[language]) || Object.values(dialogLanguages).includes(language) || language === 'zh-Hans';
    uiLanguage = supportsLanguage ? language : 'en';
    selectedLanguage = uiLanguage;
    if (userSelected) languageUserSelected = true;
    applyCopy();
  };

  const blockSubmit = (form, blocked) => {
    if (!form) return;
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((button) => {
      if (blocked && !button.disabled) {
        button.disabled = true;
        button.dataset.registrationControllerDisabled = 'true';
      } else if (!blocked && button.dataset.registrationControllerDisabled === 'true') {
        button.disabled = false;
        delete button.dataset.registrationControllerDisabled;
      }
    });
  };

    const positionProofOfPurchaseNote = (form) => {
    if (!form) return false;

    const control =
      form.querySelector('.globo-form-control[data-element-id="file2-1"]')
      || form.querySelector('[data-element-id="file2-1"]');

    const note =
      control?.querySelector('.help-text.globo-description');

    const upload =
      control?.querySelector('.globo-form-input');

    if (!control || !note || !upload) return false;

    upload.before(note);

    return true;
  };


  const numericFormId = (value) => {
    const rawValue = String(value || '').trim();
    if (/^\d+$/.test(rawValue)) return rawValue;
    const idMatch = rawValue.match(/(?:^|-)globo-formbuilder-(\d+)$/);
    if (idMatch) return idMatch[1];
    try {
      const decodedValue = window.atob(rawValue);
      return /^\d+$/.test(decodedValue) ? decodedValue : '';
    } catch (error) {
      return '';
    }
  };

  const formIdFromHost = (formHost) => {
    if (!formHost) return '';
    const form = formHost.querySelector('form');
    const action = String(form?.getAttribute('action') || '');
    const candidates = [
      formHost.dataset.id,
      formHost.id,
      form?.dataset.id,
      form?.getAttribute('data-id'),
      form?.querySelector('.block-container[data-id]')?.dataset.id,
      action.match(/\/api\/front\/form\/(\d+)\/send/)?.[1]
    ];
    return candidates.map(numericFormId).find(Boolean) || '';
  };

  const formBlockRegistry = () => {
    const records = Array.from(document.querySelectorAll(formHostSelector)).map((formHost) => ({
      formId: formIdFromHost(formHost),
      formHost,
      wrapper: formHost.closest('.shopify-app-block') || formHost
    }));
    const byId = new Map();
    records.forEach((record) => {
      if (record.formId && !byId.has(record.formId)) byId.set(record.formId, record);
    });
    return { records, byId };
  };

  const setActiveFormBlock = (formId = '', interactive = false) => {
    const targetFormId = String(formId || '');
    const registry = formBlockRegistry();
    const activeRecord = registry.byId.get(targetFormId) || null;
    registry.records.forEach((record) => {
      const isActive = record === activeRecord;
      const isInteractive = isActive && interactive;
      record.wrapper.hidden = !isActive;
      record.wrapper.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      record.wrapper.toggleAttribute('inert', !isInteractive);
      record.formHost.toggleAttribute('inert', !isInteractive);
      blockSubmit(record.formHost.querySelector('form'), !isInteractive);
    });
    return activeRecord;
  };

  const activeFormRecord = () => formBlockRegistry().byId.get(activeFormId) || null;

  const resetCurrentForm = () => {
    const form = activeFormRecord()?.formHost.querySelector('form');
    if (!form) return;
    form.reset();
    form.querySelectorAll('.block-container.errors, .help-block.error').forEach((element) => element.remove());
  };

  const collectUnconditionalFieldIds = (elements, fieldIds = new Set()) => {
    if (!Array.isArray(elements)) return fieldIds;
    elements.forEach((element) => {
      if (!element || typeof element !== 'object') return;
      const fieldId = String(element.id || '');
      const shouldBeVisible = fieldId
        && element.conditionalField === false
        && element.hidden !== true
        && String(element.displayType || '').toLowerCase() === 'show';
      if (shouldBeVisible) fieldIds.add(fieldId);
      collectUnconditionalFieldIds(element.elements, fieldIds);
    });
    return fieldIds;
  };

  const repairUnconditionalFields = (form, runtime, formId) => {
    const unconditionalFieldIds = collectUnconditionalFieldIds(runtime?.forms?.[formId]?.elements);
    if (!unconditionalFieldIds.size) return;
    form.querySelectorAll('.globo-form-control[data-element-id]').forEach((control) => {
      if (!unconditionalFieldIds.has(control.dataset.elementId || '')) return;
      control.removeAttribute('data-display-type');
      control.classList.remove('conditional-field');
      control.style.removeProperty('display');
    });
  };

  const syncFormMetadata = (form, runtime = window.Globo?.FormBuilder, formId = activeFormId) => {
    if (!form || !purchaseCountry) return;
    const fields = {
      purchase_country: purchaseCountry,
      selected_language: selectedLanguage,
      detected_country: detectedCountry,
      shopify_market: shopifyMarket,
      registration_version: config.registrationVersion || 'phase-1'
    };
    Object.entries(fields).forEach(([name, value]) => {
      let input = form.querySelector(`input[type="hidden"][name="${name}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value || '';
    });
    const countryField = form.querySelector('select[name="country-1"]');
    const matchingOption = countryField && Array.from(countryField.options).find((option) => option.value === formCountryValues[purchaseCountry]);
    if (matchingOption) {
      countryField.value = matchingOption.value;
      countryField.dispatchEvent(new Event('input', { bubbles: true }));
      countryField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    repairUnconditionalFields(form, runtime, formId);
    positionProofOfPurchaseNote(form);
    bindWarrantyEndDate(form, formId);

    requestAnimationFrame(() => {
      repairUnconditionalFields(form, runtime, formId);
      positionProofOfPurchaseNote(form);
      bindWarrantyEndDate(form, formId);
    });

  };

  const getFormRuntime = (formId) => {
    const runtime = window.Globo?.FormBuilder;
    return runtime?.forms?.[formId] ? runtime : null;
  };

  const waitForFormRuntime = (formId, requestId) => new Promise((resolve) => {
    let intervalId = 0;
    let timeoutId = 0;
    const finish = (runtime) => {
      document.removeEventListener('globo.formbuilder.form.loaded', check, true);
      window.clearInterval(intervalId);
      window.clearTimeout(timeoutId);
      resolve(runtime);
    };
    const check = () => {
      if (requestId !== formRequestId) return finish(null);
      const runtime = getFormRuntime(formId);
      if (runtime) finish(runtime);
    };
    document.addEventListener('globo.formbuilder.form.loaded', check, true);
    intervalId = window.setInterval(check, 250);
    timeoutId = window.setTimeout(() => finish(null), 30000);
    check();
  });

  const positionFormLoadError = (formSection) => {
    if (formSection && formLoadError && formLoadError.nextElementSibling !== formSection) {
      formSection.insertAdjacentElement('beforebegin', formLoadError);
    }
  };

  const hideFormLoadError = () => {
    if (formLoadError) formLoadError.hidden = true;
    body.dataset.registrationFormError = 'false';
  };

  const showFormLoadError = (error) => {
    applyCopy();
    if (formLoadError) formLoadError.hidden = false;
    body.dataset.registrationFormError = 'true';
    console.error('Registration form runtime did not become ready.', error);
  };

  const renderedFormId = (formHost) => {
    const form = formHost?.querySelector('form');
    if (!form) return '';
    return formIdFromHost(formHost);
  };

  const renderedFormForId = (formHost, formId) => renderedFormId(formHost) === formId
    ? formHost.querySelector('form')
    : null;

  const formHostMatches = (candidate, formHost) => Boolean(candidate?.nodeType && formHost?.nodeType)
    && (candidate === formHost || formHost.contains(candidate) || candidate.contains(formHost));

  const collectFormElements = (elements, result = []) => {
    if (!Array.isArray(elements)) return result;
    elements.forEach((element) => {
      if (!element || typeof element !== 'object') return;
      result.push(element);
      collectFormElements(element.elements, result);
    });
    return result;
  };

  const fieldByName = (form, name) => Array.from(form?.querySelectorAll('[name]') || [])
    .find((field) => field.getAttribute('name') === name) || null;

  const hasRequiredDateAndSelectEnhancements = (form, formDefinition) => {
    const elements = collectFormElements(formDefinition?.elements);
    const dateElement = elements.find((element) => String(element.id || '') === 'datetime-2');
    if (dateElement) {
      const dateInput = fieldByName(form, 'datetime-2');
      if (!dateInput?._flatpickr || dateInput._flatpickr.config?.dateFormat !== 'Y-m-d') return false;
    }
    return !elements
      .filter((element) => element.type === 'select' && String(element.id || '') !== 'country-1')
      .some((element) => {
        const select = fieldByName(form, String(element.id || ''));
        const control = select?.closest('.globo-form-control');
        return !select || (!select._gfbNiceSelect?.update
          && !select.nextElementSibling?.classList?.contains('nice-select')
          && !control?.querySelector('.nice-select, .gfb__dropdown-button'));
      });
  };

  const hasFloatingLabelStructure = (form, formDefinition) => {
    const appearance = formDefinition?.appearance || {};
    const usesFloatingLabels = String(appearance.style || '').includes('material') || Boolean(appearance.theme_design);
    if (!usesFloatingLabels) return true;
    const input = Array.from(form.querySelectorAll('.globo-form-input input, .globo-form-input textarea'))
      .find((field) => !field.disabled && !field.readOnly && !['hidden', 'file', 'checkbox', 'radio', 'submit', 'button'].includes(field.type));
    const label = input?.closest('.globo-form-control')?.querySelector('.globo-label, legend');
    return Boolean(input && label);
  };

  const getEnhancementState = (formHost, runtime, formId, loadedEventSeen) => {
    const form = renderedFormForId(formHost, formId);
    if (!form) return { ready: false, reason: 'Expected form markup is not present.' };
    if (activeFormId !== formId) return { ready: false, reason: 'The active form ID does not match the expected form ID.' };

    const loadedHost = runtime.loadedForms?.[formId];
    const loadedHostMatches = formHostMatches(loadedHost, formHost);
    if (!loadedEventSeen && !loadedHostMatches) return { ready: false, reason: 'Powerful Form loaded lifecycle has not completed.' };

    const formDefinition = runtime.forms?.[formId];
    const dateInput = fieldByName(form, 'datetime-2');
    if (dateInput && !dateInput._flatpickr) return { ready: false, reason: 'Purchase Date Flatpickr is not mounted.' };
    if (dateInput?._flatpickr && dateInput._flatpickr.config?.dateFormat !== 'Y-m-d') return { ready: false, reason: 'Purchase Date format is not Y-m-d.' };
    if (!hasRequiredDateAndSelectEnhancements(form, formDefinition)) return { ready: false, reason: 'Required date or select enhancements are not mounted.' };
    if (!hasFloatingLabelStructure(form, formDefinition)) return { ready: false, reason: 'Floating-label field structure is incomplete.' };
    return { ready: true, form };
  };

  const waitForFormEnhancements = ({ formHost, runtime, formId, requestId, country, language, timeoutMs }) => new Promise((resolve) => {
    let intervalId = 0;
    let timeoutId = 0;
    let loadedEventSeen = false;
    let lastReason = 'Powerful Form enhancements are still loading.';
    const finish = (result) => {
      document.removeEventListener('globo.formbuilder.form.loaded', onLoaded, true);
      window.clearInterval(intervalId);
      window.clearTimeout(timeoutId);
      resolve(result);
    };
    const isCurrentRequest = () => requestId === formRequestId
      && purchaseCountry === country
      && selectedLanguage === language
      && formIdFor(purchaseCountry, selectedLanguage) === formId;
    const eventHostMatches = (eventHost) => formHostMatches(eventHost, formHost);
    const check = () => {
      if (!isCurrentRequest()) return finish({ ready: false, stale: true, reason: 'Form request was superseded.' });
      const state = getEnhancementState(formHost, runtime, formId, loadedEventSeen);
      lastReason = state.reason || lastReason;
      if (state.ready) finish(state);
    };
    const onLoaded = (event) => {
      const loadedFormId = String(event.detail?.formId || '');
      if (!isCurrentRequest() || loadedFormId !== formId || !eventHostMatches(event.detail?.form)) return;
      loadedEventSeen = true;
      check();
    };
    document.addEventListener('globo.formbuilder.form.loaded', onLoaded, true);
    intervalId = window.setInterval(check, 200);
    timeoutId = window.setTimeout(() => finish({ ready: false, reason: lastReason }), timeoutMs);
    check();
  });

  const configureForm = async () => {
    const requestId = ++formRequestId;
    formConfigurationInFlight = true;
    const selectedConfig = countryConfig(purchaseCountry);
    const formId = formIdFor(purchaseCountry, selectedLanguage);
    const internationalAllowed = shell !== 'international' || config.internationalEnabled === true;
    const formAllowed = purchaseCountry !== 'OTHER' && selectedConfig?.formEnabled === true && /^\d+$/.test(formId) && internationalAllowed;
    const formSection = document.querySelector(formSectionSelector);

    positionFormLoadError(formSection);
    hideFormLoadError();
    body.dataset.registrationFormReady = 'false';
    activeFormId = '';
    formSection?.setAttribute('aria-hidden', 'true');
    setActiveFormBlock();

    if (!formAllowed) {
      if (purchaseCountry !== 'OTHER' && selectedConfig?.formEnabled === true && formId && !/^\d+$/.test(formId)) {
        console.warn(`Registration form is not configured for ${purchaseCountry} / ${selectedLanguage}.`);
      }
      updateSafeContentVisibility();
      if (statusElement) {
        if (purchaseCountry === 'OTHER') statusElement.textContent = currentCopy().other;
        else if (shell === 'international' && config.internationalEnabled !== true) statusElement.textContent = currentCopy().internationalOff;
        else statusElement.textContent = currentCopy().pending;
      }
      if (requestId === formRequestId) formConfigurationInFlight = false;
      return;
    }

    activeFormId = formId;
    const activeRecord = setActiveFormBlock(formId, false);
    if (!activeRecord) {
      activeFormId = '';
      updateSafeContentVisibility();
      showFormLoadError(new Error(`The native App Block for form ${formId} was not found.`));
      formConfigurationInFlight = false;
      return;
    }

    const formHost = activeRecord.formHost;
    const runtime = await waitForFormRuntime(formId, requestId);
    if (requestId !== formRequestId) return;
    if (!runtime) {
      updateSafeContentVisibility();
      showFormLoadError(new Error('Powerful Form runtime timed out.'));
      formConfigurationInFlight = false;
      return;
    }
    try {
      const state = await waitForFormEnhancements({
        formHost, runtime, formId, requestId, country: purchaseCountry, language: selectedLanguage, timeoutMs: 30000
      });
      if (state.stale) return;
      if (!state.ready || !state.form) throw new Error(state.reason || 'Powerful Form enhancements did not become ready.');
      const form = state.form;
      syncFormMetadata(form, runtime, formId);
      setActiveFormBlock(formId, true);
      formSection?.removeAttribute('aria-hidden');
      activeFormId = formId;
      body.dataset.registrationFormReady = 'true';
      updateSafeContentVisibility();
      if (statusElement) statusElement.textContent = '';
    } catch (error) {
      activeFormId = '';
      setActiveFormBlock();
      updateSafeContentVisibility();
      showFormLoadError(error);
    } finally {
      if (requestId === formRequestId) formConfigurationInFlight = false;
    }
  };

  const updateSubscriptionVisibility = () => {
    const subscription = document.querySelector('[data-registration-subscription]');
    const subscriptionSection = subscription?.closest('.shopify-section');

    const marketCountryMatches =
      (shell === 'us' && purchaseCountry === 'US')
      || (shell === 'uk' && purchaseCountry === 'GB');

    const eligible = Boolean(
      marketCountryMatches
      && subscription?.dataset.productAvailable === 'true'
    );

    body.dataset.registrationSubscriptionVisible = eligible ? 'true' : 'false';

    if (subscription) subscription.hidden = !eligible;

    subscriptionSection?.setAttribute(
      'aria-hidden',
      eligible ? 'false' : 'true'
    );
  };

  const applyPurchaseCountry = async (country, options = {}) => {
    const nextCountry = normalizeCountry(country);
    if (purchaseCountry && purchaseCountry !== nextCountry) resetCurrentForm();
    purchaseCountry = nextCountry;
    selectedLanguage = resolveLanguageForCountry(purchaseCountry, options.selectedLanguage || defaultLanguageForCountry(purchaseCountry));
    activeLanguage = selectedLanguage;
    uiLanguage = selectedLanguage;
    dialogLanguageCountry = purchaseCountry;
    countryConfirmationRequired = false;
    body.dataset.registrationPurchaseCountry = purchaseCountry;
    document.documentElement.dataset.registrationPurchaseCountry = purchaseCountry;
    updateSubscriptionVisibility();
    applyCopy();
    document.querySelectorAll('[data-registration-current-country]').forEach((element) => { element.textContent = localizedCountryName(purchaseCountry); });
    document.querySelectorAll('[data-registration-open-policy]').forEach((element) => { element.hidden = purchaseCountry === 'OTHER'; });
    if (countrySelect) countrySelect.value = purchaseCountry;
    updateSafeContentVisibility();

    const selectedConfig = countryConfig(purchaseCountry);
    if (warrantySummary) { warrantySummary.innerHTML = selectedConfig?.warrantySummary || ''; warrantySummary.hidden = !selectedConfig?.warrantySummary; }
    if (warrantyBenefit) { warrantyBenefit.innerHTML = selectedConfig?.warrantyBenefit || ''; warrantyBenefit.hidden = !selectedConfig?.warrantyBenefit; }
    if (options.persist !== false) {
      try {
        localStorage.setItem(storageKey, purchaseCountry);
        localStorage.setItem(languageStorageKey, selectedLanguage);
      } catch (error) {}
    }

    window.SoocasRegistrationState = {
      purchaseCountry, selectedLanguage, detectedCountry, shopifyMarket, shell,
      registrationVersion: config.registrationVersion || 'phase-1', formId: ''
    };
    await configureForm();
    window.SoocasRegistrationState.formId = activeFormId;
    document.dispatchEvent(new CustomEvent('soocas:registration-country-change', { detail: window.SoocasRegistrationState }));
  };

  const openCountryPicker = (options = {}) => {
    countryConfirmationRequired = options.required === true;
    countrySelectionTouched = false;
    languageUserSelected = false;
    dialogLanguageCountry = normalizeCountry(options.languageCountry || purchaseCountry || detectedCountry || browsingCountry || marketPurchaseCountry || 'OTHER');
    const openingLanguage = purchaseCountry && dialogLanguageCountry === purchaseCountry
      ? activeLanguage
      : defaultLanguageForCountry(dialogLanguageCountry);
    selectedLanguage = resolveLanguageForCountry(dialogLanguageCountry, options.selectedLanguage || openingLanguage);
    uiLanguage = selectedLanguage;
    if (countryDialogClose) countryDialogClose.hidden = countryConfirmationRequired;
    if (countrySelect) countrySelect.value = options.selectedCountry || purchaseCountry || marketPurchaseCountry || 'OTHER';
    applyCopy();
    setDialogState(countryDialog, true);
    requestAnimationFrame(releasePriorityGate);
  };

  const closeCountryPicker = () => {
    if (countryConfirmationRequired) return;
    selectedLanguage = activeLanguage;
    uiLanguage = activeLanguage;
    dialogLanguageCountry = purchaseCountry;
    applyCopy();
    setDialogState(countryDialog, false);
  };

  const openPolicy = () => {
    const selectedConfig = countryConfig(purchaseCountry);
    const hasPolicy = purchaseCountry !== 'OTHER' && selectedConfig?.policyEnabled === true && selectedConfig.policyText;
    if (policyContent) policyContent.innerHTML = hasPolicy ? selectedConfig.policyText : `<p>${currentCopy().policyPending}</p>`;
    setDialogState(policyDialog, true);
  };

  const fetchDetectedCountry = async () => {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timeout = setTimeout(() => controller?.abort(), 3500);
    let detected = '';
    try {
      const response = await fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' }, signal: controller?.signal });
      if (response.ok) {
        const payload = await response.json();
        const handle = String(payload?.detected_values?.country?.handle || '').toUpperCase();
        if (/^[A-Z]{2}$/.test(handle)) detected = handle;
      }
    } catch (error) {
      detected = '';
    } finally {
      clearTimeout(timeout);
    }
    return detected;
  };

  const clearRoutedCountry = () => {
    if (!routedCountry || !window.history?.replaceState) return;
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('registration_country');
    window.history.replaceState(window.history.state, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
  };

  const hydrateDetectedCountry = async () => {
    const detected = await fetchDetectedCountry();
    if (!detected) return;
    detectedCountry = detected;
    if (window.SoocasRegistrationState) window.SoocasRegistrationState.detectedCountry = detectedCountry;
    syncFormMetadata(activeFormRecord()?.formHost.querySelector('form'));
  };

  const requestCountrySuggestion = async () => {
    const initialSuggestion = previewDetectionCountry || (validCountry(browsingCountry) ? normalizeCountry(browsingCountry) : '');
    detectedCountry = initialSuggestion;
    purchaseCountry = '';
    openCountryPicker({ required: true, languageCountry: initialSuggestion || 'OTHER', selectedCountry: initialSuggestion || 'OTHER' });
    if (previewDetectionCountry) {
      applyCopy();
      return;
    }
    const fetchedCountry = await fetchDetectedCountry();
    detectedCountry = fetchedCountry || '';
    const suggestion = validCountry(detectedCountry) ? normalizeCountry(detectedCountry) : '';
    dialogLanguageCountry = suggestion || 'OTHER';
    if (!countrySelectionTouched && countrySelect) countrySelect.value = suggestion || 'OTHER';
    if (!languageUserSelected) {
      selectedLanguage = defaultLanguageForCountry(dialogLanguageCountry);
      uiLanguage = selectedLanguage;
    }
    applyCopy();
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-registration-open-picker]')) openCountryPicker({ required: false });
    if (event.target.closest('[data-registration-open-policy]')) openPolicy();
    if (event.target.closest('[data-registration-open-privacy]')) {
      event.preventDefault();
      setDialogState(privacyDialog, true);
    }
  });
  root.querySelector('[data-registration-confirm-country]')?.addEventListener('click', async () => {
    const selectedCountry = normalizeCountry(countrySelect?.value || 'OTHER');
    selectedLanguage = resolveLanguageForCountry(selectedCountry, selectedLanguage);
    try {
      localStorage.setItem(storageKey, selectedCountry);
      localStorage.setItem(languageStorageKey, selectedLanguage);
    } catch (error) {}
    if (switchStorefrontShell(selectedCountry)) return;
    setDialogState(countryDialog, false);
    await applyPurchaseCountry(selectedCountry, { selectedLanguage });
  });
  countrySelect?.addEventListener('change', () => {
    countrySelectionTouched = true;
    dialogLanguageCountry = normalizeCountry(countrySelect.value);
    languageUserSelected = false;
    setUiLanguage(defaultLanguageForCountry(dialogLanguageCountry));
  });
  localLanguageButton?.addEventListener('click', () => setUiLanguage(localLanguageButton.dataset.language || 'en', true));
  englishLanguageButton?.addEventListener('click', () => setUiLanguage(englishLanguageButton.dataset.language || 'en', true));
  formRefreshButton?.addEventListener('click', () => window.location.reload());
  countryDialogClose?.addEventListener('click', closeCountryPicker);
  root.querySelector('[data-registration-close-policy]')?.addEventListener('click', () => setDialogState(policyDialog, false));
  root.querySelector('[data-registration-close-privacy]')?.addEventListener('click', () => setDialogState(privacyDialog, false));

  document.addEventListener('keydown', (event) => {
    if (!countryDialog.hidden) {
      if (event.key === 'Escape') {
        if (countryConfirmationRequired) event.preventDefault(); else closeCountryPicker();
      } else trapFocus(event, countryDialog);
    } else if (!policyDialog.hidden) {
      if (event.key === 'Escape') setDialogState(policyDialog, false); else trapFocus(event, policyDialog);
    } else if (privacyDialog && !privacyDialog.hidden) {
      if (event.key === 'Escape') setDialogState(privacyDialog, false); else trapFocus(event, privacyDialog);
    }
  });

  document.addEventListener('globo.formbuilder.form.loaded', (event) => {
    const loadedFormId = String(event.detail?.formId || '');
    const loadedHost = event.detail?.form;
    const loadedRecord = formBlockRegistry().byId.get(loadedFormId) || null;
    const loadedHostMatches = formHostMatches(loadedHost, loadedRecord?.formHost);
    const currentForm = loadedHost?.matches?.('form')
      ? loadedHost
      : loadedHost?.querySelector?.('form') || loadedRecord?.formHost.querySelector('form');
    setActiveFormBlock(activeFormId, body.dataset.registrationFormReady === 'true');
    if (loadedHostMatches && loadedFormId === activeFormId && loadedFormId === formIdFor(purchaseCountry, selectedLanguage)) {
      syncFormMetadata(currentForm, window.Globo?.FormBuilder, loadedFormId);
    }
    const expectedFormId = formIdFor(purchaseCountry, selectedLanguage);
    if (loadedHostMatches && loadedFormId === expectedFormId && !formConfigurationInFlight && activeFormId !== expectedFormId && getFormRuntime(expectedFormId)) configureForm();
  }, true);

  document.addEventListener('globo.formbuilder.form.submitted', (event) => {
    const submittedId = String(event.detail?.formId || '');
    const formHost = activeFormRecord()?.formHost;
    if (!formHostMatches(event.detail?.form, formHost) || submittedId !== activeFormId) return;
    const submittedForm = event.detail.form?.matches?.('form')
      ? event.detail.form
      : event.detail.form?.querySelector?.('form') || formHost.querySelector('form');
    const successDetail = buildRegistrationSuccessDetail(submittedForm);
updateSubscriptionVisibility();
    document.dispatchEvent(new CustomEvent('soocas:registration-success', { detail: successDetail }));
  }, true);

  const initialize = async () => {
    let storedCountry = '';
    let storedLanguage = '';
    try {
      storedCountry = localStorage.getItem(storageKey) || '';
      storedLanguage = localStorage.getItem(languageStorageKey) || '';
    } catch (error) {}
    if (previewCountry && validCountry(previewCountry)) {
      await applyPurchaseCountry(previewCountry, { persist: false });
      releasePriorityGate();
      return hydrateDetectedCountry();
    }
    if (validCountry(routedCountry)) {
      if (switchStorefrontShell(routedCountry)) return;
      await applyPurchaseCountry(routedCountry, { selectedLanguage: storedLanguage });
      clearRoutedCountry();
      releasePriorityGate();
      return hydrateDetectedCountry();
    }
    if (!previewReset && validCountry(storedCountry)) {
      if (switchStorefrontShell(storedCountry)) return;
      await applyPurchaseCountry(storedCountry, { selectedLanguage: storedLanguage });
      releasePriorityGate();
      return hydrateDetectedCountry();
    }
    purchaseCountry = '';
    body.dataset.registrationPurchaseCountry = '';
    updateSafeContentVisibility();
    return requestCountrySuggestion();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
